<template>
	<div class="w-e-text-container_user">
		<Editor v-model="html" :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated" />
	</div>
</template>

<script>
	import Vue from 'vue'
	import {
		Editor,
		Toolbar
	} from '@wangeditor/editor-for-vue'

	import axios from 'axios'
	export default Vue.extend({
		components: {
			Editor,
			Toolbar
		},
		props: {
			value: {

			}
		},
		watch: {
			value: {
				handler(val) {
					if (val !== this.currentValue) {
						this.html = val === null ? "" : val;
					}
				},
				immediate: true,
			},
		},
		data() {
			return {
				uploadUrl: process.env.VUE_APP_BASE_API + "/common/upload", // 上传的图片服务器地址
				headers: {},
				editor: null,
				html: '',
				toolbarConfig: {
					excludeKeys: [
						'emotion', // 排除菜单组，写菜单组 key 的值即可
						"insertLink", // 插入链接
						// 上传图片
						{
							key: "group-image",
							title: "图片",
							iconSvg: '<svg viewBox="0 0 1024 1024"><path d="M959.877 128…l224.01-384 256 320h64l224.01-192z"></path></svg>',
							menuKeys: Array(2)
						},
						// 上传视频
						{
							key: "group-video",
							title: "视频",
							iconSvg: '<svg viewBox="0 0 1024 1024"><path d="M981.184 160….904zM384 704V320l320 192-320 192z"></path></svg>',
							menuKeys: Array(2)
						},
					]
				},
				mode: 'default', // or 'simple'
				editorConfig: {
					placeholder: '',
					readOnly: true,
					MENU_CONF: {
						// 配置上传图片
						uploadImage: {
							customUpload: this.update
						},
						// 继续其他菜单配置...
						uploadVideo: {
							customUpload: this.update
						},
						fontSize: {
							fontSizeList: [
								'12px',
								'14px',
								'16px',
								'17px',
								'24px',
								'32px',
								'40px',
							]
						}
						// lineHeight: {
						//   lineHeightList: ['1', '1.5', '2', '2.5']
						// }
					}
				}
			}
		},
		methods: {
			onCreated(editor) {
				this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
			},
			//自定义上传图片
			update(file, insertFn) {
				let formData = new FormData()
				formData.append('file', file)
				axios({
					method: 'post',
					url: this.uploadUrl,
					data: formData,
					headers: this.headers
				}).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						console.log("上传成功")
						let url = process.env.VUE_APP_BASE_API + res.data.fileName
						insertFn(url)
					} else {
						this.$modal.msgError("插入失败");
					}
				})
			},
			getContent() {
				return this.editor.getHtml()
			},
			setText(contentText) {
				this.editor.setHtml(contentText)
			},
		},
		//   watch: {
		//     value: {
		//       handler(val) {
		//         if (val !== this.currentValue) {
		//           this.currentValue = val === null ? "" : val;
		//           if (this.Quill) {
		//             this.Quill.pasteHTML(this.currentValue);
		//           }
		//         }
		//       },
		//       immediate: true,
		//     },
		//   },
		mounted() {
			// 模拟 ajax 请求，异步渲染编辑器

		},
		beforeDestroy() {
			const editor = this.editor
			if (editor == null) return
			editor.destroy() // 组件销毁时，及时销毁编辑器
		}
	})
</script>


<style lang="scss">
	@import url("~@wangeditor/editor/dist/css/style.css");

	.w-e-modal button {
		height: auto;
	}

	.w-e-text-container span {
		color: #000;
	}

	.w-e-text-container p {
		line-height: 2;
	}

	.w-e-text-container_user {
		background: none
	}

	.wangcontent {
		&:nth-of-type {
			border: none
		}
	}
</style>
